import { Image } from '@acme/assets';
import { PasswordInput } from '@acme/foundation';
import { Button } from 'flowbite-react';
import { useState } from 'react';

interface TwoFactorPasswordInputProps {
  onSubmit: (password: string) => void;
  loading?: boolean;
  error?: string | null;
  title?: string;
  noImage?: boolean;
  className?: string;
}

export const TwoFactorPasswordInput = ({
  onSubmit,
  loading,
  error,
  title,
  noImage,
  className = '',
}: TwoFactorPasswordInputProps) => {
  const [password, setPassword] = useState('');

  return (
    <div className={`flex flex-col gap-4 w-full items-center ${className}`}>
      {title && (
        <div className="text-xl w-full font-semibold justify-center text-center flex leading-[normal] mb-6">
          {title}
        </div>
      )}
      {!noImage && (
        <div className="flex items-center justify-center w-40 mb-8">
          <Image
            name="acces"
            width="100%"
            className="flex-grow text-center"
            loading="lazy"
          />
        </div>
      )}

      <PasswordInput
        name="twoFactorPassword"
        value={password}
        onChange={setPassword}
      />

      {error && (
        <div className="text-sm text-red-600 leading-tight w-full">{error}</div>
      )}

      <Button
        className="w-full mt-2"
        color="primary"
        onClick={() => onSubmit(password)}
        disabled={loading || !password}
      >
        Вход
      </Button>
    </div>
  );
};
